export default {
  businessLogisticsCompanyBusiness: {
    header: {
      name: '业务名称',
    },
    table: {
      name: '物流业务编码',
      full: '业务全称',
      abbreviation: '业务简称',
      priority: '优先级',
      DefaultMarkup: '默认上升幅度（不含税）',
      ProfitMargin: '利润率（不含税）',
      errTip: '请输入大于0小于100的值',
      maxL: '包裹最大长度',
      maxW: '包裹最大实际重量',
      maxVw: '包裹最大体积重',
    },
    dialog: {
      businessPlaceholder: '请输入业务名称',
      priorityMessage: '数值越小，优先级越高',
      priorityRulesMsg: '请输入优先级',
    },
    setting: {
      title: '派送渠道设置',
      channelCode: '渠道编码',
      channelName: '渠道名称',
      logisticsChannelType: '物流渠道类型',
      supplier: '供应商',
      status: '状态',
      createdOn: '创建时间',
      channelRules: '渠道规则',
      labelRules: '面单规则',
      deliveryTrackingNumberSettings: '派送单号设置',
      zones: '分区',
      trackingDataFetchSettings: '轨迹抓取设置',
      serviceZones: '普通分区', 
      remoteZones: '偏远分区',
    },
  },
};
